import { render, staticRenderFns } from "./IconVerlichtingKruis.vue?vue&type=template&id=2446ab32"
import script from "./IconVerlichtingKruis.vue?vue&type=script&lang=ts"
export * from "./IconVerlichtingKruis.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports